module.exports = __webpack_public_path__ + "img/image10.b507497a.png";